import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Navigate } from 'react-router-dom';
import { LogIn, Shield, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import Layout from '../components/layout/Layout';

const LoginPage = () => {
  const { login, isAuthenticated, loading } = useAuth();
  const { language } = useLanguage();

  if (loading) {
    return (
      <Layout>
        <div className="min-h-[80vh] flex items-center justify-center">
          <Loader2 className="w-12 h-12 animate-spin text-slate-600" />
        </div>
      </Layout>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/lina" replace />;
  }

  return (
    <Layout>
      <div className="min-h-[80vh] flex items-center justify-center bg-slate-50 py-12 px-4">
        <div className="max-w-md w-full space-y-8">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-6">
                <Shield className="w-8 h-8 text-slate-700" />
              </div>
              <h2 className="text-3xl font-light text-slate-800 mb-2">
                {language === 'en' ? 'Admin Access' : 'Accès Admin'}
              </h2>
              <p className="text-slate-500 mb-8">
                {language === 'en' 
                  ? 'Sign in with Google to access the admin panel' 
                  : 'Connectez-vous avec Google pour accéder au panneau admin'
                }
              </p>
            </div>

            <Button 
              onClick={login}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white py-6 rounded-xl flex items-center justify-center gap-3"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              {language === 'en' ? 'Sign in with Google' : 'Se connecter avec Google'}
            </Button>

            <div className="mt-6 text-center text-sm text-slate-400">
              {language === 'en' 
                ? 'Only authorized administrators can access this area' 
                : 'Seuls les administrateurs autorisés peuvent accéder à cette zone'
              }
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
